import tmhRequest from "@/config/tmhRequest";

export default {
  searchStoreJoinMemberStatusReportColumn: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/joinmemberstatusreport/searchstorejoinmemberstatusreportcolumn",
      method: "post",
      data: data
    });
  },

  searchStoreJoinMemberStatusReportCount: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/joinmemberstatusreport/searchstorejoinmemberstatusreportcount",
      method: "post",
      data: data
    });
  },

  searchStoreJoinMemberStatusReportByPage: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/joinmemberstatusreport/searchstorejoinmemberstatusreportbypage",
      method: "post",
      data: data
    });
  },

  searchEmployeeJoinMemberStatusReportColumn: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/joinmemberstatusreport/searchemployeejoinmemberstatusreportcolumn",
      method: "post",
      data: data
    });
  },

  searchEmployeeJoinMemberStatusReportCount: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/joinmemberstatusreport/searchemployeejoinmemberstatusreportcount",
      method: "post",
      data: data
    });
  },

  searchEmployeeJoinMemberStatusReportByPage: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/joinmemberstatusreport/searchemployeejoinmemberstatusreportbypage",
      method: "post",
      data: data
    });
  },

  searchDetailJoinMemberStatusReportColumn: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/joinmemberstatusreport/searchdetailjoinmemberstatusreportcolumn",
      method: "post",
      data: data
    });
  },

  searchDetailJoinMemberStatusReportCount: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/joinmemberstatusreport/searchdetailjoinmemberstatusreportcount",
      method: "post",
      data: data
    });
  },

  searchDetailJoinMemberStatusReportByPage: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/joinmemberstatusreport/searchdetailjoinmemberstatusreportbypage",
      method: "post",
      data: data
    });
  },

  searchListJoinMemberStatusReport: function(data) {
    return tmhRequest({
      url:
        "/report/ispa/joinmemberstatusreport/searchlistjoinmemberstatusreport",
      method: "post",
      data: data
    });
  },
  searchMemberAnalysisReportByPage: function(data) {
    return tmhRequest({
      url: "/report/ispa/memberanalysisreport/searchmemberanalysisreportbypage",
      method: "post",
      data: data
    });
  },
  exportJoinMemberStatusReport: function(data) {
    return tmhRequest({
      url: "/report/ispa/joinmemberstatusreport/exportjoinmemberstatusreport",
      method: "post",
      responseType: "blob",
      data: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/ispa/report/joinmemberstatusreport.js